import axios from "axios";
import { getCSRFToken } from "../csrfToken";

let configPromise = null;

const getAppConfig = async () => {
  if (configPromise) {
    return configPromise;
  }

  configPromise = (async () => {
    const tokenResponse = await getCSRFToken();

    const response = await axios.request({
      method: "POST",
      url: "/api/config",
      data: {},
      headers: {
        "X-CSRF-Token": tokenResponse.data.csrfToken,
      },
      withCredentials: true,
    });

    return response.data;
  })();

  return configPromise;
};

export default getAppConfig;